<button class="more-options-btn"
        #displayButton
        [class.filter-btn-active]="showFilter"
        (click)="toggleFilterDisplay()">
  <i class="far fa-eye"></i>
  <div translate="TOOLBAR.DISPLAY"></div>
  <i class="far fa-chevron-down"></i>
</button>

<div id="filter"
     class="estimate-filter-container"
     [class.detailed]="isDetailedBudgetType"
     [style.maxHeight.px]="menuHeight"
     [@inOutAnimation]
     #displayOptions
     *ngIf="showFilter">
  <div class="scrollable-filter-wrapper">
    <div>
      <span class="filter-header"
            translate="OPTIONS.SECTIONS"></span>
      <div class="filter-list-container">
        <div class="filter-option"
             *ngFor="let hiddenSection of currentSectionFilters">
          <!-- We should set the checkbox to true if hiddenSection.selected === false (reversed value) -->
          <input type="checkbox"
                 [id]="'section-filter' + hiddenSection.key"
                 [ngModel]="!hiddenSection.selected"
                 (ngModelChange)="hiddenSection.selected = !$event"
                 binary="true" />
          <label [for]="'section-filter' + hiddenSection.key"
                 [translate]="hiddenSection.titleKey">
          </label>
        </div>
      </div>
    </div>

    <div>
      <span class="filter-header"
            translate="OPTIONS.DEPARTMENTS"></span>
      <div class="filter-search-container">
        <i class="far fa-search"></i>
        <input #filter
               class="filter-input"
               type="text"
               (keyup)="query(filter.value)" />
      </div>
      <div class="filter-option">
        <input type="checkbox"
               id="dept-select-all"
               (change)="selectAll($event)"
               binary="true" />
        <label for="dept-select-all"
               translate="BUTTON.SELECT">
        </label>
      </div>
      <div class="filter-list-container">
        <div class="filter-option"
             *ngFor="let dept of filteredDepartmentVMs">
          <input type="checkbox"
                 [id]="'dept-filter' + dept.department.code"
                 [(ngModel)]="dept.isSelected"
                 (change)="onSelect($event, dept)"
                 binary="true" />
          <label [for]="'dept-filter' + dept.department.code">
            {{ dept.department.code }} &#8226; {{ dept.department.description }}
          </label>
        </div>
      </div>
    </div>
  </div>

  <div class="filter-btn-container">
    <button class="filter-btn"
            (click)="saveChanges()">OK</button>
  </div>
</div>
